export default "__VITE_ASSET__BFHZO8ji__"